import { render, staticRenderFns } from "./SendMessageTemplate.vue?vue&type=template&id=026dfa46&"
import script from "./SendMessageTemplate.vue?vue&type=script&lang=ts&"
export * from "./SendMessageTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports